"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BitstraySantasTokenFactory = void 0;
const contracts_1 = require("@ethersproject/contracts");
class BitstraySantasTokenFactory extends contracts_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(_bitstraysDAO, _descriptor, _seeder, _proxyRegistry, overrides) {
        return super.deploy(_bitstraysDAO, _descriptor, _seeder, _proxyRegistry, overrides || {});
    }
    getDeployTransaction(_bitstraysDAO, _descriptor, _seeder, _proxyRegistry, overrides) {
        return super.getDeployTransaction(_bitstraysDAO, _descriptor, _seeder, _proxyRegistry, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static connect(address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.BitstraySantasTokenFactory = BitstraySantasTokenFactory;
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_bitstraysDAO",
                type: "address",
            },
            {
                internalType: "contract IBitstraysDescriptor",
                name: "_descriptor",
                type: "address",
            },
            {
                internalType: "contract IBitstraysSeeder",
                name: "_seeder",
                type: "address",
            },
            {
                internalType: "contract IProxyRegistry",
                name: "_proxyRegistry",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "BitstraySantaBurned",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "arms",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "shirt",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "motive",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "eyes",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "mouth",
                        type: "uint48",
                    },
                ],
                indexed: false,
                internalType: "struct IBitstraysSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "BitstraySantaCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "bitstraysDAO",
                type: "address",
            },
        ],
        name: "BitstraysDAOUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "delegator",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "fromDelegate",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "toDelegate",
                type: "address",
            },
        ],
        name: "DelegateChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "delegate",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "previousBalance",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newBalance",
                type: "uint256",
            },
        ],
        name: "DelegateVotesChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DescriptorLocked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract IBitstraysDescriptor",
                name: "descriptor",
                type: "address",
            },
        ],
        name: "DescriptorUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "enabled",
                type: "bool",
            },
        ],
        name: "PublicMintActive",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "SeederLocked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract IBitstraysSeeder",
                name: "seeder",
                type: "address",
            },
        ],
        name: "SeederUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [],
        name: "DELEGATION_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DOMAIN_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_BITSTRAYSANTAS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_TOKENS_MINTED_BY_ADDRESS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "bitstraysDAO",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "bitstrayId",
                type: "uint256",
            },
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        name: "checkpoints",
        outputs: [
            {
                internalType: "uint32",
                name: "fromBlock",
                type: "uint32",
            },
            {
                internalType: "uint96",
                name: "votes",
                type: "uint96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "contractURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "dataURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegatee",
                type: "address",
            },
        ],
        name: "delegate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegatee",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "expiry",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "delegateBySig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegator",
                type: "address",
            },
        ],
        name: "delegates",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "descriptor",
        outputs: [
            {
                internalType: "contract IBitstraysDescriptor",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getCurrentVotes",
        outputs: [
            {
                internalType: "uint96",
                name: "",
                type: "uint96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "blockNumber",
                type: "uint256",
            },
        ],
        name: "getPriorVotes",
        outputs: [
            {
                internalType: "uint96",
                name: "",
                type: "uint96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
        ],
        name: "giftTo",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isDescriptorLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isMintActive",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isSeederLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lockDescriptor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "lockSeeder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "mint",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
        ],
        name: "mintTo",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "numCheckpoints",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxyRegistry",
        outputs: [
            {
                internalType: "contract IProxyRegistry",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "publicMint",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "remainingReserve",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "reserveMinted",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "reserved",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "seeder",
        outputs: [
            {
                internalType: "contract IBitstraysSeeder",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "seeds",
        outputs: [
            {
                internalType: "uint48",
                name: "background",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "arms",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "shirt",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "motive",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "head",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "eyes",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "mouth",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_bitstraysDAO",
                type: "address",
            },
        ],
        name: "setBitstraysDAO",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "newContractURIHash",
                type: "string",
            },
        ],
        name: "setContractURIHash",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IBitstraysDescriptor",
                name: "_descriptor",
                type: "address",
            },
        ],
        name: "setDescriptor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IBitstraysSeeder",
                name: "_seeder",
                type: "address",
            },
        ],
        name: "setSeeder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "toggleIsMintActive",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "tokenByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "tokenOfOwnerByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegator",
                type: "address",
            },
        ],
        name: "votesToDelegate",
        outputs: [
            {
                internalType: "uint96",
                name: "",
                type: "uint96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "withdraw",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode = "0x60016012556015805462ff0000191662010000179055600a6016556000601755610100604052602e60a0818152906200526760c03980516200004a91601a91602090910190620001ea565b50601b80546001600160a01b0319908116733f0580f99cd9672cb69911afef46365134ab51e917909155601c805490911690553480156200008a57600080fd5b506040516200529538038062005295833981016040819052620000ad9162000290565b6040518060400160405280600e81526020016d426974737472617953616e74617360901b8152506040518060400160405280600e81526020016d42495453545241592d53414e544160901b815250620001156200010f6200019660201b60201c565b6200019a565b81516200012a906001906020850190620001ea565b50805162000140906002906020840190620001ea565b5050600f80546001600160a01b03199081166001600160a01b03978816179091556010805482169587169590951790945550601180549093169190931617905560601b6001600160601b0319166080526200034e565b3390565b600080546001600160a01b038381166001600160a01b0319831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b828054620001f890620002f8565b90600052602060002090601f0160209004810192826200021c576000855562000267565b82601f106200023757805160ff191683800117855562000267565b8280016001018555821562000267579182015b82811115620002675782518255916020019190600101906200024a565b506200027592915062000279565b5090565b5b808211156200027557600081556001016200027a565b60008060008060808587031215620002a757600080fd5b8451620002b48162000335565b6020860151909450620002c78162000335565b6040860151909350620002da8162000335565b6060860151909250620002ed8162000335565b939692955090935050565b600181811c908216806200030d57607f821691505b602082108114156200032f57634e487b7160e01b600052602260045260246000fd5b50919050565b6001600160a01b03811681146200034b57600080fd5b50565b60805160601c614ef362000374600039600081816108f40152612d300152614ef36000f3fe60806040526004361061038c5760003560e01c80636fcfff45116101dc578063b88d4fde11610102578063e7a324dc116100a0578063f0503e801161006f578063f0503e8014610a98578063f1127ed814610b7e578063f2fde38b14610bfd578063fe60d12c14610c1d57600080fd5b8063e7a324dc14610a0f578063e8a3d48514610a43578063e9580e9114610a58578063e985e9c514610a7857600080fd5b8063c3cda520116100dc578063c3cda52014610990578063c87b56dd146109b0578063c8fc0c23146109d0578063d50b31eb146109ef57600080fd5b8063b88d4fde14610936578063baedc1c414610956578063c1b8e4e11461097657600080fd5b80638740683d1161017a578063a22cb46511610149578063a22cb465146108a2578063b4b5ea57146108c2578063b50cbd9f146108e2578063b57e50011461091657600080fd5b80638740683d146108445780638da5cb5b1461085a57806395d89b4114610878578063a060ae181461088d57600080fd5b8063755edd17116101b6578063755edd171461079a578063776f7a8a146107ba578063782d6fe1146107da5780637ecebe001461081757600080fd5b80636fcfff451461071d57806370a0823114610765578063715018a61461078557600080fd5b8063313ce567116102c15780634f6ccce71161025f5780635c19a95c1161022e5780635c19a95c146106a85780635f295a67146106c85780636352211e146106dd578063684931ed146106fd57600080fd5b80634f6ccce714610628578063587cde1e146106485780635ac1e3bb146106685780635b92ac0d1461068857600080fd5b806342842e0e1161029b57806342842e0e146105bc57806342966c68146105dc57806349fb340d146105fc5780634c81433f1461061257600080fd5b8063313ce567146105785780633ccfd60b1461059f57806341b5d0de146105a757600080fd5b80631692ca911161032e57806323b872dd1161030857806323b872dd1461050357806326092b83146105235780632f745c5914610538578063303e74df1461055857600080fd5b80631692ca911461049a57806318160ddd146104ba57806320606b70146104cf57600080fd5b8063081812fc1161036a578063081812fc1461040a578063095ea7b3146104425780631249c58b1461046257806313a60cee1461048557600080fd5b806301b9a3971461039157806301ffc9a7146103b357806306fdde03146103e8575b600080fd5b34801561039d57600080fd5b506103b16103ac3660046144b0565b610c33565b005b3480156103bf57600080fd5b506103d36103ce3660046146dc565b610d52565b60405190151581526020015b60405180910390f35b3480156103f457600080fd5b506103fd610dae565b6040516103df9190614a09565b34801561041657600080fd5b5061042a610425366004614886565b610e40565b6040516001600160a01b0390911681526020016103df565b34801561044e57600080fd5b506103b161045d366004614617565b610ee6565b34801561046e57600080fd5b50610477611018565b6040519081526020016103df565b34801561049157600080fd5b506103b1611202565b3480156104a657600080fd5b50600f5461042a906001600160a01b031681565b3480156104c657600080fd5b50600954610477565b3480156104db57600080fd5b506104777f8cad95687ba82c2ce50e74f7b754645e5117c3a5bec8151c0726d5857980a86681565b34801561050f57600080fd5b506103b161051e366004614523565b6112c6565b34801561052f57600080fd5b5061047761134d565b34801561054457600080fd5b50610477610553366004614617565b61155f565b34801561056457600080fd5b5060105461042a906001600160a01b031681565b34801561058457600080fd5b5061058d600081565b60405160ff90911681526020016103df565b6103b1611607565b3480156105b357600080fd5b506103b161169f565b3480156105c857600080fd5b506103b16105d7366004614523565b6117a2565b3480156105e857600080fd5b506103b16105f7366004614886565b6117bd565b34801561060857600080fd5b5061047760125481565b34801561061e57600080fd5b5061047760175481565b34801561063457600080fd5b50610477610643366004614886565b61184e565b34801561065457600080fd5b5061042a6106633660046144b0565b6118f2565b34801561067457600080fd5b506103fd610683366004614886565b611924565b34801561069457600080fd5b506015546103d39062010000900460ff1681565b3480156106b457600080fd5b506103b16106c33660046144b0565b611a5e565b3480156106d457600080fd5b506103b1611a7c565b3480156106e957600080fd5b5061042a6106f8366004614886565b611b85565b34801561070957600080fd5b5060115461042a906001600160a01b031681565b34801561072957600080fd5b506107506107383660046144b0565b600d6020526000908152604090205463ffffffff1681565b60405163ffffffff90911681526020016103df565b34801561077157600080fd5b506104776107803660046144b0565b611c10565b34801561079157600080fd5b506103b1611caa565b3480156107a657600080fd5b506104776107b53660046144b0565b611d10565b3480156107c657600080fd5b506104776107d53660046144b0565b611e25565b3480156107e657600080fd5b506107fa6107f5366004614617565b61217e565b6040516bffffffffffffffffffffffff90911681526020016103df565b34801561082357600080fd5b506104776108323660046144b0565b600e6020526000908152604090205481565b34801561085057600080fd5b506104776101f481565b34801561086657600080fd5b506000546001600160a01b031661042a565b34801561088457600080fd5b506103fd61242d565b34801561089957600080fd5b5061047761243c565b3480156108ae57600080fd5b506103b16108bd3660046145e4565b61244c565b3480156108ce57600080fd5b506107fa6108dd3660046144b0565b61252f565b3480156108ee57600080fd5b5061042a7f000000000000000000000000000000000000000000000000000000000000000081565b34801561092257600080fd5b506103b16109313660046144b0565b6125b2565b34801561094257600080fd5b506103b1610951366004614564565b612672565b34801561096257600080fd5b506103b1610971366004614716565b612700565b34801561098257600080fd5b506015546103d39060ff1681565b34801561099c57600080fd5b506103b16109ab366004614643565b61276d565b3480156109bc57600080fd5b506103fd6109cb366004614886565b612a9f565b3480156109dc57600080fd5b506015546103d390610100900460ff1681565b3480156109fb57600080fd5b506103b1610a0a3660046144b0565b612b85565b348015610a1b57600080fd5b506104777fe48329057bfd03d55e49b547132e39cffd9c1820ad7b9d4c5307691425d15adf81565b348015610a4f57600080fd5b506103fd612c9d565b348015610a6457600080fd5b506107fa610a733660046144b0565b612cc5565b348015610a8457600080fd5b506103d3610a933660046144ea565b612cf1565b348015610aa457600080fd5b50610b36610ab3366004614886565b6018602052600090815260409020805460019091015465ffffffffffff8083169266010000000000008082048316936c010000000000000000000000008304841693720100000000000000000000000000000000000084048116937801000000000000000000000000000000000000000000000000900481169282821692041687565b6040805165ffffffffffff9889168152968816602088015294871694860194909452918516606085015284166080840152831660a083015290911660c082015260e0016103df565b348015610b8a57600080fd5b50610bd4610b993660046146a5565b600c60209081526000928352604080842090915290825290205463ffffffff81169064010000000090046bffffffffffffffffffffffff1682565b6040805163ffffffff90931683526bffffffffffffffffffffffff9091166020830152016103df565b348015610c0957600080fd5b506103b1610c183660046144b0565b612def565b348015610c2957600080fd5b5061047760165481565b6000546001600160a01b03163314610c925760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e657260448201526064015b60405180910390fd5b60155460ff1615610ce55760405162461bcd60e51b815260206004820152601460248201527f44657363726970746f72206973206c6f636b65640000000000000000000000006044820152606401610c89565b601080547fffffffffffffffffffffffff0000000000000000000000000000000000000000166001600160a01b0383169081179091556040519081527f6e66ab22238a5471005895947c8f57db923c2a9c9c73180eff80864c21295c1b906020015b60405180910390a150565b60007fffffffff0000000000000000000000000000000000000000000000000000000082167f780e9d63000000000000000000000000000000000000000000000000000000001480610da85750610da882612ece565b92915050565b606060018054610dbd90614c43565b80601f0160208091040260200160405190810160405280929190818152602001828054610de990614c43565b8015610e365780601f10610e0b57610100808354040283529160200191610e36565b820191906000526020600020905b815481529060010190602001808311610e1957829003601f168201915b5050505050905090565b6000818152600360205260408120546001600160a01b0316610eca5760405162461bcd60e51b815260206004820152602c60248201527f4552433732313a20617070726f76656420717565727920666f72206e6f6e657860448201527f697374656e7420746f6b656e00000000000000000000000000000000000000006064820152608401610c89565b506000908152600560205260409020546001600160a01b031690565b6000610ef182611b85565b9050806001600160a01b0316836001600160a01b03161415610f7b5760405162461bcd60e51b815260206004820152602160248201527f4552433732313a20617070726f76616c20746f2063757272656e74206f776e6560448201527f72000000000000000000000000000000000000000000000000000000000000006064820152608401610c89565b336001600160a01b0382161480610f975750610f978133612cf1565b6110095760405162461bcd60e51b815260206004820152603860248201527f4552433732313a20617070726f76652063616c6c6572206973206e6f74206f7760448201527f6e6572206e6f7220617070726f76656420666f7220616c6c00000000000000006064820152608401610c89565b6110138383612fb1565b505050565b600080546001600160a01b031633146110735760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e65726044820152606401610c89565b6101f461107f60095490565b106110f25760405162461bcd60e51b815260206004820152602f60248201527f4d696e7420776f756c6420657863656564206d617820737570706c79206f662060448201527f42697473747261792053616e74617300000000000000000000000000000000006064820152608401610c89565b60006110fc61243c565b116111495760405162461bcd60e51b815260206004820152601e60248201527f50726f6a656374207265736572766564206d696e7420657863656564656400006044820152606401610c89565b6101f461115560095490565b1015611194576017805490600061116b83614c97565b90915550506019805461118f91339190600061118683614c97565b91905055613037565b905090565b60405162461bcd60e51b815260206004820152603c60248201527f4572726f723a20596f7572206d696e7420776f756c6420657863656564206d6160448201527f7820737570706c79206f66204269747374726179732053616e746173000000006064820152608401610c89565b6000546001600160a01b0316331461125c5760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e65726044820152606401610c89565b601580547fffffffffffffffffffffffffffffffffffffffffffffffffffffffffff00ffff8116620100009182900460ff1615918202179091556040518181527fc92ade84097c0656e3ef994e2a4c32efa912cc39f90bce5b8426bc4d4d5c80cd90602001610d47565b6112d03382613406565b6113425760405162461bcd60e51b815260206004820152603160248201527f4552433732313a207472616e736665722063616c6c6572206973206e6f74206f60448201527f776e6572206e6f7220617070726f7665640000000000000000000000000000006064820152608401610c89565b6110138383836134ee565b60155460009062010000900460ff166113ce5760405162461bcd60e51b815260206004820152603960248201527f4572726f723a204d696e74207374617465206d7573742062652061637469766560448201527f20746f206d696e7420612042697473747261792053616e7461000000000000006064820152608401610c89565b601254336000908152601360205260409020546113ec906001614b05565b11156114605760405162461bcd60e51b815260206004820152602d60248201527f4572726f723a204164647265737320616c7265616479206d696e74656420426960448201527f747374726179732053616e7461000000000000000000000000000000000000006064820152608401610c89565b61146861243c565b611474906101f4614bb6565b61148761148060095490565b60016136de565b11156114fb5760405162461bcd60e51b815260206004820152603c60248201527f4572726f723a20596f7572206d696e7420776f756c6420657863656564206d6160448201527f7820737570706c79206f66204269747374726179732053616e746173000000006064820152608401610c89565b61150361243c565b61150f906101f4614bb6565b6009541015611194576019805460009161152f9133918461118683614c97565b3360009081526013602052604081208054929350600192909190611554908490614b05565b909155509092915050565b600061156a83611c10565b82106115de5760405162461bcd60e51b815260206004820152602b60248201527f455243373231456e756d657261626c653a206f776e657220696e646578206f7560448201527f74206f6620626f756e64730000000000000000000000000000000000000000006064820152608401610c89565b506001600160a01b03919091166000908152600760209081526040808320938352929052205490565b6000546001600160a01b031633146116615760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e65726044820152606401610c89565b601b5460405147916001600160a01b03169082156108fc029083906000818181858888f1935050505015801561169b573d6000803e3d6000fd5b5050565b6000546001600160a01b031633146116f95760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e65726044820152606401610c89565b60155460ff161561174c5760405162461bcd60e51b815260206004820152601460248201527f44657363726970746f72206973206c6f636b65640000000000000000000000006044820152606401610c89565b601580547fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff001660011790556040517f593e31e306c198bef259d839f7c6dc4ff7fc10c07f76fab193a210b03704105f90600090a1565b61101383838360405180602001604052806000815250612672565b6000546001600160a01b031633146118175760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e65726044820152606401610c89565b611820816136ea565b60405181907f075b5c8286fbc1c98196dbbf0b6546f5a923008371ae46a00483dcf4297293e390600090a250565b600061185960095490565b82106118cd5760405162461bcd60e51b815260206004820152602c60248201527f455243373231456e756d657261626c653a20676c6f62616c20696e646578206f60448201527f7574206f6620626f756e647300000000000000000000000000000000000000006064820152608401610c89565b600982815481106118e0576118e0614d2e565b90600052602060002001549050919050565b6001600160a01b038082166000908152600b6020526040812054909116801561191b578061191d565b825b9392505050565b6000818152600360205260409020546060906001600160a01b03166119b15760405162461bcd60e51b815260206004820152603460248201527f426974737472617953616e746173546f6b656e3a20555249207175657279206660448201527f6f72206e6f6e6578697374656e7420746f6b656e0000000000000000000000006064820152608401610c89565b6010546000838152601860205260409081902090517f213319aa0000000000000000000000000000000000000000000000000000000081526001600160a01b039092169163213319aa91611a0a91869190600401614a1c565b60006040518083038186803b158015611a2257600080fd5b505afa158015611a36573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052610da8919081019061475f565b6001600160a01b038116611a6f5750335b611a7933826137a9565b50565b6000546001600160a01b03163314611ad65760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e65726044820152606401610c89565b601554610100900460ff1615611b2e5760405162461bcd60e51b815260206004820152601060248201527f536565646572206973206c6f636b6564000000000000000000000000000000006044820152606401610c89565b601580547fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff00ff166101001790556040517ff59561f22794afcfb1e6be5c4733f5449fd167252a96b74bb06d341fb0dac7ed90600090a1565b6000818152600360205260408120546001600160a01b031680610da85760405162461bcd60e51b815260206004820152602960248201527f4552433732313a206f776e657220717565727920666f72206e6f6e657869737460448201527f656e7420746f6b656e00000000000000000000000000000000000000000000006064820152608401610c89565b60006001600160a01b038216611c8e5760405162461bcd60e51b815260206004820152602a60248201527f4552433732313a2062616c616e636520717565727920666f7220746865207a6560448201527f726f2061646472657373000000000000000000000000000000000000000000006064820152608401610c89565b506001600160a01b031660009081526004602052604090205490565b6000546001600160a01b03163314611d045760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e65726044820152606401610c89565b611d0e6000613841565b565b60006101f4611d1e60095490565b10611d915760405162461bcd60e51b815260206004820152602f60248201527f4d696e7420776f756c6420657863656564206d617820737570706c79206f662060448201527f42697473747261792053616e74617300000000000000000000000000000000006064820152608401610c89565b6000611d9b61243c565b11611de85760405162461bcd60e51b815260206004820152601e60248201527f50726f6a656374207265736572766564206d696e7420657863656564656400006044820152606401610c89565b6101f4611df460095490565b10156111945760178054906000611e0a83614c97565b909155505060198054610da891849190600061118683614c97565b60155460009062010000900460ff16611ea65760405162461bcd60e51b815260206004820152603a60248201527f4572726f723a204d696e74207374617465206d7573742062652061637469766560448201527f20746f206d696e742061204269747374726179732053616e74610000000000006064820152608401610c89565b601c546001600160a01b0383811691161415611f2a5760405162461bcd60e51b815260206004820152603060248201527f4e756c6c2041646472657373206973206e6f7420616c6c6f77656420666f722060448201527f67696674696e6720757365206275726e000000000000000000000000000000006064820152608401610c89565b6012546001600160a01b038316600090815260136020526040902054611f51906001614b05565b1115611fc55760405162461bcd60e51b815260206004820152602f60248201527f4572726f723a204164647265737320616c7265616479206d696e74656420312060448201527f4269747374726179732053616e746100000000000000000000000000000000006064820152608401610c89565b60125433600090815260146020526040902054611fe3906001614b05565b11156120575760405162461bcd60e51b815260206004820152603360248201527f4572726f723a20416464726573732068617320616c726561647920676966746560448201527f642031204269747374726179732053616e7461000000000000000000000000006064820152608401610c89565b61205f61243c565b61206b906101f4614bb6565b61207761148060095490565b11156120eb5760405162461bcd60e51b815260206004820152603c60248201527f4572726f723a20596f7572206d696e7420776f756c6420657863656564206d6160448201527f7820737570706c79206f66204269747374726179732053616e746173000000006064820152608401610c89565b6120f361243c565b6120ff906101f4614bb6565b6009541015611194576019805460009161211f9185918461118683614c97565b6001600160a01b0384166000908152601360205260408120805492935060019290919061214d908490614b05565b9091555050336000908152601460205260408120805460019290612172908490614b05565b90915550909392505050565b60004382106121f55760405162461bcd60e51b815260206004820152603760248201527f455243373231436865636b706f696e7461626c653a3a6765745072696f72566f60448201527f7465733a206e6f74207965742064657465726d696e65640000000000000000006064820152608401610c89565b6001600160a01b0383166000908152600d602052604090205463ffffffff1680612223576000915050610da8565b6001600160a01b0384166000908152600c602052604081208491612248600185614bcd565b63ffffffff908116825260208201929092526040016000205416116122c1576001600160a01b0384166000908152600c602052604081209061228b600184614bcd565b63ffffffff16815260208101919091526040016000205464010000000090046bffffffffffffffffffffffff169150610da89050565b6001600160a01b0384166000908152600c6020908152604080832083805290915290205463ffffffff168310156122fc576000915050610da8565b60008061230a600184614bcd565b90505b8163ffffffff168163ffffffff1611156123e2576000600261232f8484614bcd565b6123399190614b6c565b6123439083614bcd565b6001600160a01b0388166000908152600c6020908152604080832063ffffffff8581168552908352928190208151808301909252549283168082526401000000009093046bffffffffffffffffffffffff16918101919091529192508714156123b657602001519450610da89350505050565b805163ffffffff168711156123cd578193506123db565b6123d8600183614bcd565b92505b505061230d565b506001600160a01b0385166000908152600c6020908152604080832063ffffffff909416835292905220546bffffffffffffffffffffffff6401000000009091041691505092915050565b606060028054610dbd90614c43565b600061118f6016546017546138a9565b6001600160a01b0382163314156124a55760405162461bcd60e51b815260206004820152601960248201527f4552433732313a20617070726f766520746f2063616c6c6572000000000000006044820152606401610c89565b3360008181526006602090815260408083206001600160a01b0387168085529083529281902080547fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff001686151590811790915590519081529192917f17307eab39ab6107e8899845ad3d59bd9653f200f220920489ca2b5937696c31910160405180910390a35050565b6001600160a01b0381166000908152600d602052604081205463ffffffff168061255a57600061191d565b6001600160a01b0383166000908152600c602052604081209061257e600184614bcd565b63ffffffff16815260208101919091526040016000205464010000000090046bffffffffffffffffffffffff169392505050565b600f546001600160a01b0316331461260c5760405162461bcd60e51b815260206004820152601f60248201527f53656e646572206973206e6f7420746865206269747374726179732044414f006044820152606401610c89565b600f80547fffffffffffffffffffffffff0000000000000000000000000000000000000000166001600160a01b0383169081179091556040519081527f27f167c68d29e189cdd0c2976a1e1a3925b27dcb7cfb941c411828570090992e90602001610d47565b61267c3383613406565b6126ee5760405162461bcd60e51b815260206004820152603160248201527f4552433732313a207472616e736665722063616c6c6572206973206e6f74206f60448201527f776e6572206e6f7220617070726f7665640000000000000000000000000000006064820152608401610c89565b6126fa848484846138b5565b50505050565b6000546001600160a01b0316331461275a5760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e65726044820152606401610c89565b805161169b90601a9060208401906143be565b60007f8cad95687ba82c2ce50e74f7b754645e5117c3a5bec8151c0726d5857980a866612798610dae565b805190602001206127a64690565b60408051602080820195909552808201939093526060830191909152306080808401919091528151808403909101815260a0830182528051908401207fe48329057bfd03d55e49b547132e39cffd9c1820ad7b9d4c5307691425d15adf60c08401526001600160a01b038b1660e084015261010083018a90526101208084018a9052825180850390910181526101408401909252815191909301207f1901000000000000000000000000000000000000000000000000000000000000610160830152610162820183905261018282018190529192506000906101a20160408051601f198184030181528282528051602091820120600080855291840180845281905260ff8a169284019290925260608301889052608083018790529092509060019060a0016020604051602081039080840390855afa1580156128ed573d6000803e3d6000fd5b5050604051601f1901519150506001600160a01b0381166129765760405162461bcd60e51b815260206004820152603660248201527f455243373231436865636b706f696e7461626c653a3a64656c6567617465427960448201527f5369673a20696e76616c6964207369676e6174757265000000000000000000006064820152608401610c89565b6001600160a01b0381166000908152600e6020526040812080549161299a83614c97565b919050558914612a125760405162461bcd60e51b815260206004820152603260248201527f455243373231436865636b706f696e7461626c653a3a64656c6567617465427960448201527f5369673a20696e76616c6964206e6f6e636500000000000000000000000000006064820152608401610c89565b87421115612a885760405162461bcd60e51b815260206004820152603660248201527f455243373231436865636b706f696e7461626c653a3a64656c6567617465427960448201527f5369673a207369676e61747572652065787069726564000000000000000000006064820152608401610c89565b612a92818b6137a9565b505050505b505050505050565b6000818152600360205260409020546060906001600160a01b0316612b2c5760405162461bcd60e51b815260206004820152603460248201527f426974737472617953616e746173546f6b656e3a20555249207175657279206660448201527f6f72206e6f6e6578697374656e7420746f6b656e0000000000000000000000006064820152608401610c89565b6010546000838152601860205260409081902090517ff228ba750000000000000000000000000000000000000000000000000000000081526001600160a01b039092169163f228ba7591611a0a91869190600401614a1c565b6000546001600160a01b03163314612bdf5760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e65726044820152606401610c89565b601554610100900460ff1615612c375760405162461bcd60e51b815260206004820152601060248201527f536565646572206973206c6f636b6564000000000000000000000000000000006044820152606401610c89565b601180547fffffffffffffffffffffffff0000000000000000000000000000000000000000166001600160a01b0383169081179091556040519081527fb3025222d01ce9a26c7f9d52bc3bfd0352366bd90a793c273fbfe1c81e0e288e90602001610d47565b6060601a604051602001612cb191906148cb565b604051602081830303815290604052905090565b6000610da8612cd383611c10565b6040518060600160405280603d8152602001614e4a603d913961393e565b6040517fc45527910000000000000000000000000000000000000000000000000000000081526001600160a01b038381166004830152600091818416917f0000000000000000000000000000000000000000000000000000000000000000169063c45527919060240160206040518083038186803b158015612d7257600080fd5b505afa158015612d86573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612daa91906144cd565b6001600160a01b03161415612dc157506001610da8565b6001600160a01b0380841660009081526006602090815260408083209386168352929052205460ff1661191d565b6000546001600160a01b03163314612e495760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e65726044820152606401610c89565b6001600160a01b038116612ec55760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201527f64647265737300000000000000000000000000000000000000000000000000006064820152608401610c89565b611a7981613841565b60007fffffffff0000000000000000000000000000000000000000000000000000000082167f80ac58cd000000000000000000000000000000000000000000000000000000001480612f6157507fffffffff0000000000000000000000000000000000000000000000000000000082167f5b5e139f00000000000000000000000000000000000000000000000000000000145b80610da857507f01ffc9a7000000000000000000000000000000000000000000000000000000007fffffffff00000000000000000000000000000000000000000000000000000000831614610da8565b600081815260056020526040902080547fffffffffffffffffffffffff0000000000000000000000000000000000000000166001600160a01b0384169081179091558190612ffe82611b85565b6001600160a01b03167f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b92560405160405180910390a45050565b6011546010546040517f422e2e99000000000000000000000000000000000000000000000000000000008152600481018490526001600160a01b0391821660248201526000928392169063422e2e999060440160e06040518083038186803b1580156130a257600080fd5b505afa1580156130b6573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906130da91906147d6565b6018600085815260200190815260200160002060008201518160000160006101000a81548165ffffffffffff021916908365ffffffffffff16021790555060208201518160000160066101000a81548165ffffffffffff021916908365ffffffffffff160217905550604082015181600001600c6101000a81548165ffffffffffff021916908365ffffffffffff16021790555060608201518160000160126101000a81548165ffffffffffff021916908365ffffffffffff16021790555060808201518160000160186101000a81548165ffffffffffff021916908365ffffffffffff16021790555060a08201518160010160006101000a81548165ffffffffffff021916908365ffffffffffff16021790555060c08201518160010160066101000a81548165ffffffffffff021916908365ffffffffffff16021790555090506040518060e00160405290816000820160009054906101000a900465ffffffffffff1665ffffffffffff1665ffffffffffff1681526020016000820160069054906101000a900465ffffffffffff1665ffffffffffff1665ffffffffffff16815260200160008201600c9054906101000a900465ffffffffffff1665ffffffffffff1665ffffffffffff1681526020016000820160129054906101000a900465ffffffffffff1665ffffffffffff1665ffffffffffff1681526020016000820160189054906101000a900465ffffffffffff1665ffffffffffff1665ffffffffffff1681526020016001820160009054906101000a900465ffffffffffff1665ffffffffffff1665ffffffffffff1681526020016001820160069054906101000a900465ffffffffffff1665ffffffffffff1665ffffffffffff168152505090506133678484613976565b827f6b8f779f024779ba7ab6f08db2fa2bb6cc2ffa567f41ae321de0d52f9b8441e8826040516133f69190600060e08201905065ffffffffffff8084511683528060208501511660208401528060408501511660408401528060608501511660608401528060808501511660808401528060a08501511660a08401528060c08501511660c08401525092915050565b60405180910390a2509092915050565b6000818152600360205260408120546001600160a01b03166134905760405162461bcd60e51b815260206004820152602c60248201527f4552433732313a206f70657261746f7220717565727920666f72206e6f6e657860448201527f697374656e7420746f6b656e00000000000000000000000000000000000000006064820152608401610c89565b600061349b83611b85565b9050806001600160a01b0316846001600160a01b031614806134d65750836001600160a01b03166134cb84610e40565b6001600160a01b0316145b806134e657506134e68185612cf1565b949350505050565b826001600160a01b031661350182611b85565b6001600160a01b03161461357d5760405162461bcd60e51b815260206004820152602960248201527f4552433732313a207472616e73666572206f6620746f6b656e2074686174206960448201527f73206e6f74206f776e00000000000000000000000000000000000000000000006064820152608401610c89565b6001600160a01b0382166135f85760405162461bcd60e51b8152602060048201526024808201527f4552433732313a207472616e7366657220746f20746865207a65726f2061646460448201527f72657373000000000000000000000000000000000000000000000000000000006064820152608401610c89565b613603838383613adc565b61360e600082612fb1565b6001600160a01b0383166000908152600460205260408120805460019290613637908490614bb6565b90915550506001600160a01b0382166000908152600460205260408120805460019290613665908490614b05565b909155505060008181526003602052604080822080547fffffffffffffffffffffffff0000000000000000000000000000000000000000166001600160a01b0386811691821790925591518493918716917fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef91a4505050565b600061191d8284614b05565b60006136f582611b85565b905061370381600084613adc565b61370e600083612fb1565b6001600160a01b0381166000908152600460205260408120805460019290613737908490614bb6565b909155505060008281526003602052604080822080547fffffffffffffffffffffffff0000000000000000000000000000000000000000169055518391906001600160a01b038416907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef908390a45050565b60006137b4836118f2565b6001600160a01b038481166000818152600b602052604080822080547fffffffffffffffffffffffff000000000000000000000000000000000000000016888616908117909155905194955093928516927f3134e8a2e6d97e929a7e54011ea5485d7d196dd5f0ba4d4ef95803e8e3fc257f9190a4600061383484612cc5565b90506126fa828483613aff565b600080546001600160a01b038381167fffffffffffffffffffffffff0000000000000000000000000000000000000000831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b600061191d8284614bb6565b6138c08484846134ee565b6138cc84848484613cbc565b6126fa5760405162461bcd60e51b815260206004820152603260248201527f4552433732313a207472616e7366657220746f206e6f6e20455243373231526560448201527f63656976657220696d706c656d656e74657200000000000000000000000000006064820152608401610c89565b6000816c01000000000000000000000000841061396e5760405162461bcd60e51b8152600401610c899190614a09565b509192915050565b6001600160a01b0382166139cc5760405162461bcd60e51b815260206004820181905260248201527f4552433732313a206d696e7420746f20746865207a65726f20616464726573736044820152606401610c89565b6000818152600360205260409020546001600160a01b031615613a315760405162461bcd60e51b815260206004820152601c60248201527f4552433732313a20746f6b656e20616c7265616479206d696e746564000000006044820152606401610c89565b613a3d60008383613adc565b6001600160a01b0382166000908152600460205260408120805460019290613a66908490614b05565b909155505060008181526003602052604080822080547fffffffffffffffffffffffff0000000000000000000000000000000000000000166001600160a01b03861690811790915590518392907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef908290a45050565b613ae7838383613e69565b611013613af3846118f2565b613afc846118f2565b60015b816001600160a01b0316836001600160a01b031614158015613b2f57506000816bffffffffffffffffffffffff16115b15611013576001600160a01b03831615613bfa576001600160a01b0383166000908152600d602052604081205463ffffffff169081613b6f576000613bc1565b6001600160a01b0385166000908152600c6020526040812090613b93600185614bcd565b63ffffffff16815260208101919091526040016000205464010000000090046bffffffffffffffffffffffff165b90506000613be88285604051806060016040528060378152602001614e8760379139613f21565b9050613bf686848484613f6d565b5050505b6001600160a01b03821615611013576001600160a01b0382166000908152600d602052604081205463ffffffff169081613c35576000613c87565b6001600160a01b0384166000908152600c6020526040812090613c59600185614bcd565b63ffffffff16815260208101919091526040016000205464010000000090046bffffffffffffffffffffffff165b90506000613cae8285604051806060016040528060368152602001614dd0603691396141af565b9050612a9785848484613f6d565b60006001600160a01b0384163b15613e5e576040517f150b7a020000000000000000000000000000000000000000000000000000000081526001600160a01b0385169063150b7a0290613d199033908990889088906004016149cd565b602060405180830381600087803b158015613d3357600080fd5b505af1925050508015613d63575060408051601f3d908101601f19168201909252613d60918101906146f9565b60015b613e13573d808015613d91576040519150601f19603f3d011682016040523d82523d6000602084013e613d96565b606091505b508051613e0b5760405162461bcd60e51b815260206004820152603260248201527f4552433732313a207472616e7366657220746f206e6f6e20455243373231526560448201527f63656976657220696d706c656d656e74657200000000000000000000000000006064820152608401610c89565b805181602001fd5b7fffffffff00000000000000000000000000000000000000000000000000000000167f150b7a02000000000000000000000000000000000000000000000000000000001490506134e6565b506001949350505050565b6001600160a01b038316613ec457613ebf81600980546000838152600a60205260408120829055600182018355919091527f6e1540171b6c0c960b71a7020d9f60077f6af931a8bbf590da0223dacf75c7af0155565b613ee7565b816001600160a01b0316836001600160a01b031614613ee757613ee78382614206565b6001600160a01b038216613efe57611013816142a3565b826001600160a01b0316826001600160a01b031614611013576110138282614352565b6000836bffffffffffffffffffffffff16836bffffffffffffffffffffffff1611158290613f625760405162461bcd60e51b8152600401610c899190614a09565b506134e68385614bf2565b6000613f9143604051806080016040528060448152602001614e0660449139614396565b905060008463ffffffff16118015613feb57506001600160a01b0385166000908152600c6020526040812063ffffffff831691613fcf600188614bcd565b63ffffffff908116825260208201929092526040016000205416145b15614074576001600160a01b0385166000908152600c602052604081208391614015600188614bcd565b63ffffffff168152602081019190915260400160002080546bffffffffffffffffffffffff92909216640100000000027fffffffffffffffffffffffffffffffff000000000000000000000000ffffffff909216919091179055614155565b60408051808201825263ffffffff80841682526bffffffffffffffffffffffff80861660208085019182526001600160a01b038b166000908152600c82528681208b8616825290915294909420925183549451909116640100000000027fffffffffffffffffffffffffffffffff00000000000000000000000000000000909416911617919091179055614109846001614b1d565b6001600160a01b0386166000908152600d6020526040902080547fffffffffffffffffffffffffffffffffffffffffffffffffffffffff000000001663ffffffff929092169190911790555b604080516bffffffffffffffffffffffff8086168252841660208201526001600160a01b038716917fdec2bacdd2f05b59de34da9b523dff8be42e5e38e818c82fdb0bae774387a724910160405180910390a25050505050565b6000806141bc8486614b45565b9050846bffffffffffffffffffffffff16816bffffffffffffffffffffffff16101583906141fd5760405162461bcd60e51b8152600401610c899190614a09565b50949350505050565b6000600161421384611c10565b61421d9190614bb6565b600083815260086020526040902054909150808214614270576001600160a01b03841660009081526007602090815260408083208584528252808320548484528184208190558352600890915290208190555b5060009182526008602090815260408084208490556001600160a01b039094168352600781528383209183525290812055565b6009546000906142b590600190614bb6565b6000838152600a6020526040812054600980549394509092849081106142dd576142dd614d2e565b9060005260206000200154905080600983815481106142fe576142fe614d2e565b6000918252602080832090910192909255828152600a9091526040808220849055858252812055600980548061433657614336614cff565b6001900381819060005260206000200160009055905550505050565b600061435d83611c10565b6001600160a01b039093166000908152600760209081526040808320868452825280832085905593825260089052919091209190915550565b600081640100000000841061396e5760405162461bcd60e51b8152600401610c899190614a09565b8280546143ca90614c43565b90600052602060002090601f0160209004810192826143ec5760008555614432565b82601f1061440557805160ff1916838001178555614432565b82800160010185558215614432579182015b82811115614432578251825591602001919060010190614417565b5061443e929150614442565b5090565b5b8082111561443e5760008155600101614443565b600061446a61446584614add565b614aac565b905082815283838301111561447e57600080fd5b828260208301376000602084830101529392505050565b805165ffffffffffff811681146144ab57600080fd5b919050565b6000602082840312156144c257600080fd5b813561191d81614d8c565b6000602082840312156144df57600080fd5b815161191d81614d8c565b600080604083850312156144fd57600080fd5b823561450881614d8c565b9150602083013561451881614d8c565b809150509250929050565b60008060006060848603121561453857600080fd5b833561454381614d8c565b9250602084013561455381614d8c565b929592945050506040919091013590565b6000806000806080858703121561457a57600080fd5b843561458581614d8c565b9350602085013561459581614d8c565b925060408501359150606085013567ffffffffffffffff8111156145b857600080fd5b8501601f810187136145c957600080fd5b6145d887823560208401614457565b91505092959194509250565b600080604083850312156145f757600080fd5b823561460281614d8c565b91506020830135801515811461451857600080fd5b6000806040838503121561462a57600080fd5b823561463581614d8c565b946020939093013593505050565b60008060008060008060c0878903121561465c57600080fd5b863561466781614d8c565b95506020870135945060408701359350606087013560ff8116811461468b57600080fd5b9598949750929560808101359460a0909101359350915050565b600080604083850312156146b857600080fd5b82356146c381614d8c565b9150602083013563ffffffff8116811461451857600080fd5b6000602082840312156146ee57600080fd5b813561191d81614da1565b60006020828403121561470b57600080fd5b815161191d81614da1565b60006020828403121561472857600080fd5b813567ffffffffffffffff81111561473f57600080fd5b8201601f8101841361475057600080fd5b6134e684823560208401614457565b60006020828403121561477157600080fd5b815167ffffffffffffffff81111561478857600080fd5b8201601f8101841361479957600080fd5b80516147a761446582614add565b8181528560208385010111156147bc57600080fd5b6147cd826020830160208601614c17565b95945050505050565b600060e082840312156147e857600080fd5b60405160e0810181811067ffffffffffffffff8211171561480b5761480b614d5d565b60405261481783614495565b815261482560208401614495565b602082015261483660408401614495565b604082015261484760608401614495565b606082015261485860808401614495565b608082015261486960a08401614495565b60a082015261487a60c08401614495565b60c08201529392505050565b60006020828403121561489857600080fd5b5035919050565b600081518084526148b7816020860160208601614c17565b601f01601f19169290920160200192915050565b7f697066733a2f2f000000000000000000000000000000000000000000000000008152600060076000845481600182811c91508083168061490d57607f831692505b6020808410821415614946577f4e487b710000000000000000000000000000000000000000000000000000000086526022600452602486fd5b81801561495a576001811461498d576149be565b7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff008616888b015287858b010196506149be565b60008b81526020902060005b868110156149b45781548c82018b0152908501908301614999565b505087858b010196505b50949998505050505050505050565b60006001600160a01b038087168352808616602084015250836040830152608060608301526149ff608083018461489f565b9695505050505050565b60208152600061191d602083018461489f565b600061010082019050838252825465ffffffffffff8082166020850152808260301c166040850152808260601c166060850152808260901c166080850152614a7360a08501828460c01c1665ffffffffffff169052565b600185015465ffffffffffff8282161660c08601529150614aa360e08501828460301c1665ffffffffffff169052565b50509392505050565b604051601f8201601f1916810167ffffffffffffffff81118282101715614ad557614ad5614d5d565b604052919050565b600067ffffffffffffffff821115614af757614af7614d5d565b50601f01601f191660200190565b60008219821115614b1857614b18614cd0565b500190565b600063ffffffff808316818516808303821115614b3c57614b3c614cd0565b01949350505050565b60006bffffffffffffffffffffffff808316818516808303821115614b3c57614b3c614cd0565b600063ffffffff80841680614baa577f4e487b7100000000000000000000000000000000000000000000000000000000600052601260045260246000fd5b92169190910492915050565b600082821015614bc857614bc8614cd0565b500390565b600063ffffffff83811690831681811015614bea57614bea614cd0565b039392505050565b60006bffffffffffffffffffffffff83811690831681811015614bea57614bea614cd0565b60005b83811015614c32578181015183820152602001614c1a565b838111156126fa5750506000910152565b600181811c90821680614c5757607f821691505b60208210811415614c91577f4e487b7100000000000000000000000000000000000000000000000000000000600052602260045260246000fd5b50919050565b60007fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff821415614cc957614cc9614cd0565b5060010190565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601160045260246000fd5b7f4e487b7100000000000000000000000000000000000000000000000000000000600052603160045260246000fd5b7f4e487b7100000000000000000000000000000000000000000000000000000000600052603260045260246000fd5b7f4e487b7100000000000000000000000000000000000000000000000000000000600052604160045260246000fd5b6001600160a01b0381168114611a7957600080fd5b7fffffffff0000000000000000000000000000000000000000000000000000000081168114611a7957600080fdfe455243373231436865636b706f696e7461626c653a3a5f6d6f766544656c6567617465733a20616d6f756e74206f766572666c6f7773455243373231436865636b706f696e7461626c653a3a5f7772697465436865636b706f696e743a20626c6f636b206e756d62657220657863656564732033322062697473455243373231436865636b706f696e7461626c653a3a766f746573546f44656c65676174653a20616d6f756e7420657863656564732039362062697473455243373231436865636b706f696e7461626c653a3a5f6d6f766544656c6567617465733a20616d6f756e7420756e646572666c6f7773a2646970667358221220fd437fb8fe3729575b57ec06be2da007e6630d5c35e99bdcc9e38b951e6642f664736f6c63430008060033516d63486f6358776534394c69767057676f7144483467757368726b5063724b5854516d68554361525232385a66";
